import React, { useState, useEffect, Fragment } from "react";
import { Container, Row, Col } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactTooltip from "react-tooltip";
import { useHistory } from "react-router-dom";

import moment from "moment";
import { Modal } from "react-bootstrap";
import NumberFormat from "react-number-format";
import { useSelector } from "react-redux";
import Select from "react-select";
import { getFundByAmc } from "../../stores/services/funds.service";
import {
  getAllDividendAnnouncements,
  postToDividendAnnouncement,
  updateDividendAnnouncement,
  changeActiveStatus,
  changePaidStatus,
  getAllActiveUnpaidDividendAnnouncementsByFund,
  getCorporateAnnouncementByID,
  getDividendDisbursementsByAnnouncementId,
  handleFinalize,
  handleUnitDisbursement,
} from "../../stores/services/dividend-announcement.service";
import { generateDividendLedgerEntries, numberWithCommas } from "../../utils/customFunction";
import AddProcessDisburement from "./processDividendDisbursementModal";
import { getLedgerInfoByCode } from "../../stores/services/chatofaccounts.service";
import ProcessDividendDisbursementModal from "./processDividendDisbursementModal";
import TableHeading from "../../components/ui/TableHeading";
import {
  processDisbursementHeadings,
  processDisbursementTabs,
} from "../../utils/ui_data";
import Tabs from "../../components/ui/Tabs";
import Button from "../../components/ui/button";
import OTPComponent from "./otp-modal";
import SendPaymentModal from "./send-payment-modal";
import DividendCard from "./AnnouncementListing";
import CardColComponent from "../genericCardComponent/CardColComponent";
import DividendTable from "./DividendTable";
import { FaFileSignature } from "react-icons/fa";
import { getAllUnitHoldersByAmc } from "../../stores/services/unit-holder.service";


const ProcessDisbursement = (props: any) => {
  const history = useHistory();
  const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);
  const email = sessionStorage.getItem("email") || "";
  const amc_name = sessionStorage.getItem("amc_name") || "";
  const amc_code = sessionStorage.getItem("amc_code") || "";
  const [fund_code, setFund_code] = useState(
    JSON.parse(sessionStorage.getItem("fund_code") || "[]")
  );
  const [fundDataLoading, setFundDataLoading] = useState(false);
  const [announcementDataLoading, setAnnouncementDataLoading] = useState(false);
  const [dividendDataLoading, setDividendDataLoading] = useState(false);
  const [ledgerTableDataLoading, setLedgerTableDataLoading] = useState(false);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [onStartFlag, setOnStartFlag] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [totalDividendVal, setTotalDividendVal] = useState<any>();

  const [fundData, setFundData] = useState<any>([]);
  const [announcementData, setAnnouncementData] = useState<any>([]);
  const [dividendData, setDividendData] = useState<any>([]);
  const [ledgerTableData, setLedgerTableData] = useState<any>([]);

  const [selectedFund, setSelectedFund] = useState("");
  const [selectedAnnoucement, setSelectedAnnoucement] = useState("");
  const [selectedUnitHolderDivident, setSelectedUnitHolderDivident] =
    useState<any>({});
  const [folio, setFolio] = useState<any>("");
  const [unitholderName, setUnitholderName] = useState<any>("");
  const [allFolios, setAllFolios] = useState<any>([]);

  const [activeTab, setActiveTab] = useState("All");
  const [processDividendData, setProcessDividendData] = useState([]);

  const [showProcessDisbursementModal, setShowProcessDisbursementModal] =
    useState(false);
  const [isVerificationModalOpen, setShowVerificationModal] = useState({
    open: false,
    state: "",
  });
  const [isDividentRefundModalOpen, setShowDividentRefundModal] =
    useState(false);
  const [apiCallDone, setApiCallDone] = useState(false);
  let totalDebitAmount = 0;
  let totalCreditAmount = 0;


  const getAllFolios = async () => {
    try {
      const response = await getAllUnitHoldersByAmc(email, amc_code);
      if (response.data.status == 200) {
        setAllFolios(response.data.data);
      }
    } catch (error) { }
  };


  React.useEffect(() => {
    getAllFolios()
    if (sessionStorage.getItem("fund_code")) {
      setFund_code(JSON.parse(sessionStorage.getItem("fund_code") || "[]"));
    } else {
      setFund_code(undefined);
    }
  }, []);

  React.useEffect(() => {
    const handleStorageChange = () => {
      const fundCode = sessionStorage.getItem("fund_code");
      setFund_code(fundCode ? JSON.parse(fundCode) : undefined);
    };

    handleStorageChange();

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const getAnnoucement = async (fundVal) => {
    try {
      setAnnouncementDataLoading(true);
      let res = await getAllDividendAnnouncements(email, amc_code, fundVal);
      if (res.data.status == 200 && res?.data?.data?.length > 0) {
        setAnnouncementData(res.data.data);
        setAnnouncementDataLoading(false);
      } else {
        // toast.error("No Record Found for Annoucement!")
        setAnnouncementData([]);
        setAnnouncementDataLoading(false);
      }
    } catch (error) {
      setAnnouncementData([]);
      setAnnouncementDataLoading(false);
    }
  };

  const selectedFundName = React.useMemo(() => {
    const selectFund = fundData.find(
      (item) => item.symbol_code === selectedFund
    );

    return selectFund && selectFund.nature === "Special Managed Account"
      ? {
        value: selectFund.symbol_code,
        label: `${selectFund.fund_name} (${selectFund.symbol_code}) - SMA`,
      }
      : selectFund
        ? {
          value: selectFund.symbol_code,
          label: `${selectFund.fund_name} (${selectFund.symbol_code})`,
        }
        : null;
  }, [fundData, selectedFund]);

  const getLedgerInfo = async (email, ledger_code, fund_code) => {
    const result = await getLedgerInfoByCode(email, ledger_code, fund_code);
    return result.data.data;
  };

  const handleSearch = async (isFlag: string = "", pageNoVal: string = "", FolioId: string = "", nameVal: string = "") => {
    if (isFlag == "") {
      setDividendDataLoading(true);
      setLedgerTableDataLoading(true);
      setDividendData([]);
      setPageNo(1)
    }
    try {
      let announcementDetails = announcementData.find(
        (item) => item.announcement_id === selectedAnnoucement
      );
      if (hasNextPage) {
        setBtnLoading(true);
      }
      let draftFilter: string = "";
      let paidFilter: string = "";
      let reinvestFilter: string = "";
      if (activeTab === "Paid") {
        paidFilter = "true";
      } else if (activeTab === "Reinvest") {
        // If 'Reinvest' means not paid and specifically reinvested
        paidFilter = "false";
        reinvestFilter = "true"; // Assuming a 'reinvest' parameter for the API
      } else if (
        activeTab === "All" ||
        // activeTab === "Pending" ||
        activeTab === "Failed"
      ) {
        draftFilter = "";
        paidFilter = "";
        reinvestFilter = "";
      } else if (activeTab === "Draft" || activeTab === "Pending") {
        draftFilter = "true";
      }
      let res = await getDividendDisbursementsByAnnouncementId(
        email,
        amc_code,
        selectedFund,
        announcementDetails.announcement_id,
        announcementDetails.announcement_number,
        draftFilter,
        paidFilter,
        reinvestFilter,
        pageNoVal || "",
        "",
        FolioId || "",
        nameVal || ""
      );
      setApiCallDone(true);
      if (res.data.status === 200 && res.data.data?.length > 0) {
        const responseUndistributedProfitLossLedger = await getLedgerInfo(
          email,
          201050101,
          selectedFund
        );
        const responseDividendDistributionPayableLedger = await getLedgerInfo(
          email,
          301030201,
          selectedFund
        );
        const responseSaleUnitLedger = await getLedgerInfo(
          email,
          201010101,
          selectedFund
        );
        const responseWHTLedger = await getLedgerInfo(
          email,
          301030502,
          selectedFund
        );
        // setLedgerTableData([
        //   //debit
        //   {
        //     account_number: "",
        //     account_title: "",
        //     amc_code: amc_code,
        //     balance: "",
        //     bank_code: "",
        //     branch: "",
        //     child_family_code:
        //       responseUndistributedProfitLossLedger.child_family_code,
        //     child_family_name:
        //       responseUndistributedProfitLossLedger.child_family_name,
        //     counter_account_number: "",
        //     counter_account_title: "",
        //     counter_bank: "",
        //     counter_branch: "",
        //     created_at: "",
        //     credit_amount: "0",
        //     debit_amount: parseFloat(
        //       res.data.totalGrossDividend || "0"
        //     ).toFixed(4),
        //     description: "Gross Dividend",
        //     doc_type: "",
        //     entered_by: "",
        //     evidence: "",
        //     family_code: responseUndistributedProfitLossLedger.family_code,
        //     family_name: responseUndistributedProfitLossLedger.family_name,
        //     fund_code: selectedFund,
        //     gl_code: responseUndistributedProfitLossLedger.gl_code,
        //     gl_name: responseUndistributedProfitLossLedger.gl_name,
        //     instruction_date: "",
        //     instrument_by: "",
        //     instrument_date: "",
        //     instrument_no: "",
        //     instrument_type: "",
        //     main_family_code:
        //       responseUndistributedProfitLossLedger.main_family_code,
        //     main_family_name:
        //       responseUndistributedProfitLossLedger.main_family_name,
        //     realized: "true",
        //     realized_by: "",
        //     realized_date: "",
        //     sub_family_code:
        //       responseUndistributedProfitLossLedger.sub_family_code,
        //     sub_family_name:
        //       responseUndistributedProfitLossLedger.sub_family_name,
        //     period: sessionStorage.getItem("active_period") || "",
        //     paid: false,
        //   },
        //   //credit
        //   {
        //     account_number: "",
        //     account_title: "",
        //     amc_code: amc_code,
        //     balance: "",
        //     bank_code: "",
        //     branch: "",
        //     child_family_code:
        //       responseDividendDistributionPayableLedger.child_family_code,
        //     child_family_name:
        //       responseDividendDistributionPayableLedger.child_family_name,
        //     counter_account_number: "",
        //     counter_account_title: "",
        //     counter_bank: "",
        //     counter_branch: "",
        //     created_at: "",
        //     credit_amount: parseFloat(
        //       res.data.totalGrossDividend || "0"
        //     ).toFixed(4),
        //     debit_amount: "0",
        //     description: "Gross Dividend",
        //     doc_type: "",
        //     entered_by: "",
        //     evidence: "",
        //     family_code: responseDividendDistributionPayableLedger.family_code,
        //     family_name: responseDividendDistributionPayableLedger.family_name,
        //     fund_code: selectedFund,
        //     gl_code: responseDividendDistributionPayableLedger.gl_code,
        //     gl_name: responseDividendDistributionPayableLedger.gl_name,
        //     instruction_date: "",
        //     instrument_by: "",
        //     instrument_date: "",
        //     instrument_no: "",
        //     instrument_type: "",
        //     main_family_code:
        //       responseDividendDistributionPayableLedger.main_family_code,
        //     main_family_name:
        //       responseDividendDistributionPayableLedger.main_family_name,
        //     realized: "true",
        //     realized_by: "",
        //     realized_date: "",
        //     sub_family_code:
        //       responseDividendDistributionPayableLedger.sub_family_code,
        //     sub_family_name:
        //       responseDividendDistributionPayableLedger.sub_family_name,
        //     period: sessionStorage.getItem("active_period") || "",
        //     paid: false,
        //   },
        //   //debit
        //   {
        //     account_number: "",
        //     account_title: "",
        //     amc_code: amc_code,
        //     balance: "",
        //     bank_code: "",
        //     branch: "",
        //     child_family_code:
        //       responseDividendDistributionPayableLedger.child_family_code,
        //     child_family_name:
        //       responseDividendDistributionPayableLedger.child_family_name,
        //     counter_account_number: "",
        //     counter_account_title: "",
        //     counter_bank: "",
        //     counter_branch: "",
        //     created_at: "",
        //     credit_amount: "0",
        //     debit_amount: parseFloat(
        //       res.data.totalRefundCapital || "0"
        //     ).toFixed(4),
        //     description: "Refund of Capital - Dividend",
        //     doc_type: "",
        //     entered_by: "",
        //     evidence: "",
        //     family_code: responseDividendDistributionPayableLedger.family_code,
        //     family_name: responseDividendDistributionPayableLedger.family_name,
        //     fund_code: selectedFund,
        //     gl_code: responseDividendDistributionPayableLedger.gl_code,
        //     gl_name: responseDividendDistributionPayableLedger.gl_name,
        //     instruction_date: "",
        //     instrument_by: "",
        //     instrument_date: "",
        //     instrument_no: "",
        //     instrument_type: "",
        //     main_family_code:
        //       responseDividendDistributionPayableLedger.main_family_code,
        //     main_family_name:
        //       responseDividendDistributionPayableLedger.main_family_name,
        //     realized: "true",
        //     realized_by: "",
        //     realized_date: "",
        //     sub_family_code:
        //       responseDividendDistributionPayableLedger.sub_family_code,
        //     sub_family_name:
        //       responseDividendDistributionPayableLedger.sub_family_name,
        //     period: sessionStorage.getItem("active_period") || "",
        //     paid: false,
        //   },
        //   //debit
        //   {
        //     account_number: "",
        //     account_title: "",
        //     amc_code: amc_code,
        //     balance: "",
        //     bank_code: "",
        //     branch: "",
        //     child_family_code:
        //       responseDividendDistributionPayableLedger.child_family_code,
        //     child_family_name:
        //       responseDividendDistributionPayableLedger.child_family_name,
        //     counter_account_number: "",
        //     counter_account_title: "",
        //     counter_bank: "",
        //     counter_branch: "",
        //     created_at: "",
        //     credit_amount: "0",
        //     debit_amount: parseFloat(
        //       (res.data?.totalNetDividend
        //         ? res.data?.totalNetDividend + res.data.totalTaxAmount
        //         : res.data.totalGrossDividend - res.data.totalTaxAmount
        //       ).toString() || "0"
        //     ).toFixed(4),
        //     description: "Reinvest Amount - Dividend",
        //     doc_type: "",
        //     entered_by: "",
        //     evidence: "",
        //     family_code: responseDividendDistributionPayableLedger.family_code,
        //     family_name: responseDividendDistributionPayableLedger.family_name,
        //     fund_code: selectedFund,
        //     gl_code: responseDividendDistributionPayableLedger.gl_code,
        //     gl_name: responseDividendDistributionPayableLedger.gl_name,
        //     instruction_date: "",
        //     instrument_by: "",
        //     instrument_date: "",
        //     instrument_no: "",
        //     instrument_type: "",
        //     main_family_code:
        //       responseDividendDistributionPayableLedger.main_family_code,
        //     main_family_name:
        //       responseDividendDistributionPayableLedger.main_family_name,
        //     realized: "true",
        //     realized_by: "",
        //     realized_date: "",
        //     sub_family_code:
        //       responseDividendDistributionPayableLedger.sub_family_code,
        //     sub_family_name:
        //       responseDividendDistributionPayableLedger.sub_family_name,
        //     period: sessionStorage.getItem("active_period") || "",
        //     paid: false,
        //   },
        //   //credit
        //   {
        //     account_number: "",
        //     account_title: "",
        //     amc_code: amc_code,
        //     balance: "",
        //     bank_code: "",
        //     branch: "",
        //     child_family_code: responseSaleUnitLedger.child_family_code,
        //     child_family_name: responseSaleUnitLedger.child_family_name,
        //     counter_account_number: "",
        //     counter_account_title: "",
        //     counter_bank: "",
        //     counter_branch: "",
        //     created_at: "",
        //     credit_amount: parseFloat(
        //       res.data.totalRefundCapital || "0"
        //     ).toFixed(4),
        //     debit_amount: "0",
        //     description: "Refund of Capital - Dividend",
        //     doc_type: "",
        //     entered_by: "",
        //     evidence: "",
        //     family_code: responseSaleUnitLedger.family_code,
        //     family_name: responseSaleUnitLedger.family_name,
        //     fund_code: selectedFund,
        //     gl_code: responseSaleUnitLedger.gl_code,
        //     gl_name: responseSaleUnitLedger.gl_name,
        //     instruction_date: "",
        //     instrument_by: "",
        //     instrument_date: "",
        //     instrument_no: "",
        //     instrument_type: "",
        //     main_family_code: responseSaleUnitLedger.main_family_code,
        //     main_family_name: responseSaleUnitLedger.main_family_name,
        //     realized: "true",
        //     realized_by: "",
        //     realized_date: "",
        //     sub_family_code: responseSaleUnitLedger.sub_family_code,
        //     sub_family_name: responseSaleUnitLedger.sub_family_name,
        //     period: sessionStorage.getItem("active_period") || "",
        //     paid: false,
        //   },
        //   //credit
        //   {
        //     account_number: "",
        //     account_title: "",
        //     amc_code: amc_code,
        //     balance: "",
        //     bank_code: "",
        //     branch: "",
        //     child_family_code: responseSaleUnitLedger.child_family_code,
        //     child_family_name: responseSaleUnitLedger.child_family_name,
        //     counter_account_number: "",
        //     counter_account_title: "",
        //     counter_bank: "",
        //     counter_branch: "",
        //     created_at: "",
        //     credit_amount: parseFloat(
        //       res.data.totalNetDividend.toString() || "0"
        //     ).toFixed(4),
        //     debit_amount: "0",
        //     description: "Reinvest - Dividend",
        //     doc_type: "",
        //     entered_by: "",
        //     evidence: "",
        //     family_code: responseSaleUnitLedger.family_code,
        //     family_name: responseSaleUnitLedger.family_name,
        //     fund_code: selectedFund,
        //     gl_code: responseSaleUnitLedger.gl_code,
        //     gl_name: responseSaleUnitLedger.gl_name,
        //     instruction_date: "",
        //     instrument_by: "",
        //     instrument_date: "",
        //     instrument_no: "",
        //     instrument_type: "",
        //     main_family_code: responseSaleUnitLedger.main_family_code,
        //     main_family_name: responseSaleUnitLedger.main_family_name,
        //     realized: "true",
        //     realized_by: "",
        //     realized_date: "",
        //     sub_family_code: responseSaleUnitLedger.sub_family_code,
        //     sub_family_name: responseSaleUnitLedger.sub_family_name,
        //     period: sessionStorage.getItem("active_period") || "",
        //     paid: false,
        //   },
        //   //credit
        //   {
        //     account_number: "",
        //     account_title: "",
        //     amc_code: amc_code,
        //     balance: "",
        //     bank_code: "",
        //     branch: "",
        //     child_family_code: responseWHTLedger.child_family_code,
        //     child_family_name: responseWHTLedger.child_family_name,
        //     counter_account_number: "",
        //     counter_account_title: "",
        //     counter_bank: "",
        //     counter_branch: "",
        //     created_at: "",
        //     credit_amount: parseFloat(
        //       res.data.totalTaxAmount.toString() || "0"
        //     ).toFixed(4),
        //     debit_amount: "0",
        //     description: "WHT - Dividend",
        //     doc_type: "",
        //     entered_by: "",
        //     evidence: "",
        //     family_code: responseWHTLedger.family_code,
        //     family_name: responseWHTLedger.family_name,
        //     fund_code: selectedFund,
        //     gl_code: responseWHTLedger.gl_code,
        //     gl_name: responseWHTLedger.gl_name,
        //     instruction_date: "",
        //     instrument_by: "",
        //     instrument_date: "",
        //     instrument_no: "",
        //     instrument_type: "",
        //     main_family_code: responseWHTLedger.main_family_code,
        //     main_family_name: responseWHTLedger.main_family_name,
        //     realized: "true",
        //     realized_by: "",
        //     realized_date: "",
        //     sub_family_code: responseWHTLedger.sub_family_code,
        //     sub_family_name: responseWHTLedger.sub_family_name,
        //     period: sessionStorage.getItem("active_period") || "",
        //     paid: false,
        //   },
        // ]);
        setTotalDividendVal(res?.data)

        const ledgerEntries = generateDividendLedgerEntries({
          amc_code,
          fund_code: selectedFund,
          grossDividend: parseFloat(res?.data?.totalGrossDividend || "0"),
          netDividend: parseFloat(res?.data?.totalNetDividend || "0"),
          refundCapital: parseFloat(res?.data?.totalRefundCapital || "0"),
          taxAmount: parseFloat(res?.data?.totalTaxAmount || "0"),
          undistributedLedger: responseUndistributedProfitLossLedger,
          payableLedger: responseDividendDistributionPayableLedger,
          saleUnitLedger: responseSaleUnitLedger,
          whtLedger: responseWHTLedger,

        });

        setLedgerTableData(ledgerEntries);

        setDividendData(
          isFlag == ""
            ? [...res?.data?.data]
            : [...dividendData, ...res?.data?.data]
        );
        setHasNextPage(res?.data?.page_info?.hasNextPage || false);
        setLedgerTableDataLoading(false);
        setDividendDataLoading(false);
      } else if (res.data.status === 200) {
        setHasNextPage(false);
        setLedgerTableData([]);
        setDividendData([]);
        toast.success(res?.data?.message || res?.message);
        setLedgerTableDataLoading(false);

        setDividendDataLoading(false);
      } else {
        setHasNextPage(false);
        setLedgerTableData([]);
        setDividendData([]);
        toast.error(res?.data?.message || res?.message);
        setLedgerTableDataLoading(false);

        setDividendDataLoading(false);
      }
      setBtnLoading(false);
    } catch (error) {
      setHasNextPage(false);
      setBtnLoading(false);
      setLedgerTableData([]);
      setDividendData([]);
      setLedgerTableDataLoading(false);

      setDividendDataLoading(false);
      toast.error("No data found!");
    }
  };

  useEffect(() => {
    setFundDataLoading(true);
    const getFundByAMcCode = async (code: string) => {
      setFundData([]);

      try {
        const response = await getFundByAmc(
          email,
          code,
          fund_code?.length > 0 ? fund_code : ""
        );
        // sort data
        let sortedData: any = [];
        sortedData = response.data.data.sort(function (a, b) {
          let x = a.nature.toLowerCase();
          let y = b.nature.toLowerCase();
          if (x > y) {
            return 1;
          }
          if (x < y) {
            return -1;
          }
          return 0;
        });
        if (sortedData.length === 1) {
          setSelectedFund(sortedData[0].fund_code);
        }
        // setAllFunds(response.data.data);
        setFundData(sortedData);
        setFundDataLoading(false);
      } catch (error) { }
    };

    getFundByAMcCode(amc_code);
  }, []);

  const renderAnnoucementDropdown = () => {
    return announcementData?.map((item: any, index: string) => {
      return {
        value: item?.announcement_id,
        label: `${moment(item?.to_date)?.format("DD-MMM-YYYY")} - ${item?.description?.length > 30 ? item?.description?.slice(0, 30) + "..." : item?.description}`,
      };
    });
  };

  const renderFundsDropdown = () => {
    return fundData.map((item: any, index: string) => {
      if (item.nature === "Special Managed Account") {
        return {
          value: item.symbol_code,
          label: `${item.fund_name} (${item.symbol_code}) - SMA`,
        };
      } else {
        return {
          value: item.symbol_code,
          label: `${item.fund_name} (${item.symbol_code})`,
        };
      }
    });
  };

  const handleShowMore = () => {
    const pageNoVal = pageNo + 1;
    setPageNo((prev) => prev + 1);
    handleSearch("true", pageNoVal?.toString(), folio, unitholderName);
  };

  useEffect(() => {
    if (selectedAnnoucement) {
      setPageNo(0);
      handleSearch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  const renderAllFoliosDropdown = () => {
    return allFolios.map((item: any, index: number) => {
      return {
        label: `${item?.folio_no?.replace("UNITHOLDER_", "")} - (${item?.name})`,
        value: item?.folio_no?.replace("UNITHOLDER_", ""),
      };
    });
  };


  const selectedAnnouncementVal = React.useMemo(() => {
    const selected = announcementData.find(
      (item) => item?.announcement_id === selectedAnnoucement
    );
    return selected
      ? {
        value: selected?.announcement_id,
        finalized: selected?.entitlements_finalized,
        paid: selected?.paid,
        label: `${moment(selected?.to_date)?.format("DD-MMM-YYYY")} - ${selected?.description}`,
      }
      : null;
  }, [announcementData, selectedAnnoucement]);

  const selectedFolioVal = React.useMemo(() => {
    const selected = allFolios?.find(
      (item) => item?.folio_no?.replace("UNITHOLDER_", "") === folio
    );
    return selected
      ? {
        value: selected?.folio_no?.replace("UNITHOLDER_", ""),
        label: `${selected?.folio_no?.replace("UNITHOLDER_", "")} - (${selected?.name})`,
      }
      : null;
  }, [allFolios, folio]);


  const customStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      background: isFocused
        ? "hsla(291, 64%, 42%, 0.5)"
        : isSelected
          ? "hsla(291, 64%, 42%, 1)"
          : undefined,
      zIndex: 1,
    }),
    menuList: (styles) => ({
      ...styles,
      background: theme == "dark" ? "#3b3b3b" : "#ffffff",
      color: theme == "dark" ? "white" : "",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 100,
    }),
    control: (base, state) => ({
      ...base,
      background: theme == "dark" ? "#25273a" : "#f2f2f2",
      borderRadius: "0.4285rem",
      borderColor: state.isFocused
        ? "#1d8cf8"
        : theme !== "light"
          ? "#2b3553"
          : "",
      boxShadow: state.isFocused ? null : null,
      "&:hover": {
        borderColor: state.isFocused ? "" : "#ba54f5",
      },
      '& .react-select__input input[type="color"]': {
        color: theme === "dark" ? "red" : "black",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: theme == "dark" ? "white" : "black",
    }),
    input: (base) => ({
      ...base,
      color: theme == "dark" ? "white" : "black",
    }),
  };

  const renderModalForDisbursementProcessing = () => {
    if (showProcessDisbursementModal) {
      return (
        <Modal
          className=""
          dialogClassName="announcementModal"
          show={true}
          size="xl"
          backdrop={true}
          onHide={() => {
            setShowProcessDisbursementModal(false);
          }}
        >
          <div className="modal-header">
            <button
              aria-hidden={true}
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => {
                setShowProcessDisbursementModal(false);
              }}
            >
              <i className="tim-icons icon-simple-remove" />
            </button>
            <h6 className="title title-up">Process Dividend Entitlements</h6>
          </div>

          <div className="modal-body">
            <ProcessDividendDisbursementModal />
          </div>
        </Modal>
      );
    }
  };

  const resetSearch = () => {
    setFolio("")
    setUnitholderName("")
  }

  return (
    <>
      <ToastContainer />

      <div className="content">
        <Row>
          <Col md="12">
            <Container fluid>
              {
                fundDataLoading ? (
                  <Row>
                    <Col>
                      <div className="d-flex justify-content-center my-5">
                        <i
                          className="fa fa-spinner fa-spin fa-3x"
                          aria-hidden="true"
                        ></i>
                      </div>
                    </Col>
                  </Row>
                ) : (
                  <>
                    <Row>
                      <Col>
                        <div className="card mb-3">
                          <div className="card-header d-flex align-items-center justify-content-between">
                            <h4 className="card-title">Process Entitlements</h4>
                            <div
                            >
                              <button
                                className=" btn-round btn-icon btn btn-success"
                                onClick={() => {
                                  setShowProcessDisbursementModal(true);
                                }}
                              >
                                <i className="fa fa-plus"></i>
                              </button>
                            </div>
                          </div>
                          <div className="card-body">
                            <Row className="align-items-center">
                              <Col
                                xl={3}
                                lg={3}
                                md={4}
                                sm={12}
                                xs={12}
                                className="form-group col-md-4"
                                data-tip="Select Fund"
                              >
                                Fund Name*
                                <ReactTooltip
                                  textColor="white"
                                  backgroundColor="black"
                                  effect="float"
                                />
                                {fundDataLoading ? (
                                  <div className="form-control w-100">
                                    <i className="fa fa-spinner fa-spin fa-1x"></i>
                                  </div>
                                ) : (
                                  <Select
                                    disabled={false}
                                    value={selectedFundName}
                                    label={
                                      selectedFund
                                        ? "No Fund Found"
                                        : "Select Fund"
                                    }
                                    onChange={(e) => {
                                      setLedgerTableData([]);
                                      setAnnouncementData([]);
                                      setDividendData([]);
                                      getAnnoucement(e?.value);
                                      setSelectedFund(e?.value);
                                      setSelectedAnnoucement("");
                                      setActiveTab("All");
                                      setFolio("")
                                      setUnitholderName("")
                                      setApiCallDone(false);
                                    }}
                                    menuPortalTarget={document.body}
                                    menuShouldBlockScroll={true}
                                    isClearable={true}
                                    isSearchable={true}
                                    name="color"
                                    options={renderFundsDropdown()}
                                    styles={customStyles}
                                  />
                                )}
                              </Col>
                              <Col
                                xl={3}
                                lg={3}
                                md={4}
                                sm={12}
                                xs={12}
                                className="form-group col-md-4"
                                data-tip="Select Announcement"
                              >
                                Announcement*
                                <ReactTooltip
                                  textColor="white"
                                  backgroundColor="black"
                                  effect="float"
                                />
                                {announcementDataLoading ? (
                                  <div className="form-control w-100">
                                    <i className="fa fa-spinner fa-spin fa-1x"></i>
                                  </div>
                                ) : (
                                  <Select
                                    isDisabled={!selectedFund}
                                    value={selectedAnnouncementVal}
                                    label={
                                      selectedFund
                                        ? "No Announcement Found"
                                        : "Select Announcement"
                                    }
                                    onChange={(e) => {
                                      setLedgerTableData([]);
                                      setDividendData([]);
                                      setSelectedAnnoucement(e?.value);
                                      setActiveTab("All");
                                      setApiCallDone(false);
                                      setFolio("")
                                      setUnitholderName("")
                                    }}
                                    menuPortalTarget={document.body}
                                    menuShouldBlockScroll={true}
                                    isClearable={true}
                                    isSearchable={true}
                                    name="color"
                                    options={renderAnnoucementDropdown()}
                                    styles={customStyles}
                                  />
                                )}
                              </Col>
                              <Col xl={2} lg={3} md={4} sm={12} xs={12}>
                                <button
                                  style={{
                                    marginTop: "20px",
                                  }}
                                  className="btn btn-primary py-2"
                                  disabled={
                                    fundDataLoading ||
                                    announcementDataLoading ||
                                    !selectedFund ||
                                    !selectedAnnoucement ||
                                    dividendDataLoading
                                  }
                                  onClick={() => {
                                    setFolio("")
                                    setUnitholderName("")
                                    handleSearch();
                                  }}
                                >
                                  {dividendDataLoading ? (
                                    <>
                                      <span
                                        className="spinner-border login-txt spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                      ></span>
                                      <span className="login-txt">
                                        {" "}
                                        Searching...
                                      </span>
                                    </>
                                  ) : (
                                    "Search"
                                  )}
                                </button>
                              </Col>
                              <Col
                                xl={4}
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                className="mt-3"
                              >
                                <Tabs
                                  tabs={processDisbursementTabs}
                                  activeTab={activeTab}
                                  setActiveTab={setActiveTab}
                                  resetSearch={resetSearch}
                                />
                              </Col>
                            </Row>

                            {selectedFund && selectedAnnoucement && (
                              <>
                                {selectedAnnoucement &&
                                  <>
                                    <Row>
                                      <Col>
                                        <DividendCard data={announcementData?.find(
                                          (item) => item?.announcement_id === selectedAnnoucement
                                        )} />
                                      </Col>
                                    </Row>

                                    <Row className="align-items-center">
                                      <Col
                                        xl={3}
                                        lg={3}
                                        md={4}
                                        sm={12}
                                        xs={12}
                                        className="form-group col-md-4"
                                        data-tip="Select Folio"
                                      >
                                        Select Folio
                                        <ReactTooltip
                                          textColor="white"
                                          backgroundColor="black"
                                          effect="float"
                                        />
                                        <Select
                                          value={selectedFolioVal}
                                          label={"Select Folio"}
                                          onChange={(e: any) => {
                                            setFolio(e?.value);
                                            handleSearch("", "", e?.value, unitholderName || "")
                                          }}
                                          menuPortalTarget={document.body}
                                          menuShouldBlockScroll={true}
                                          isClearable={true}
                                          isSearchable={true}
                                          name="color"
                                          options={renderAllFoliosDropdown()}
                                          styles={customStyles}
                                        />

                                      </Col>
                                      <Col
                                        xl={3}
                                        lg={3}
                                        md={4}
                                        sm={12}
                                        xs={12}
                                        className="form-group col-md-4"
                                        data-tip="Select Name"
                                      >
                                        Enter Name
                                        <ReactTooltip
                                          textColor="white"
                                          backgroundColor="black"
                                          effect="float"
                                        />
                                        <input
                                          style={{ paddingTop: "6px", paddingBottom: "6px" }}
                                          type="search"
                                          id="myInput"
                                          placeholder="Search Name"
                                          data-tip="Search Name"
                                          onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                              handleSearch("", "", folio || "", unitholderName)
                                            }
                                          }}
                                          className="form-control"
                                          value={unitholderName}
                                          onChange={(e) => {
                                            setUnitholderName(e.target.value);
                                            if (e.target.value === "") {
                                              handleSearch("", "", folio || "", "")
                                            }
                                          }}
                                        />
                                      </Col>
                                    </Row>
                                  </>
                                }

                                {dividendDataLoading && (
                                  <div className="text-center my-5">
                                    <div
                                      className="spinner-border text-primary mb-3"
                                      role="status"
                                    >
                                      <span className="visually-hidden">
                                        Loading...
                                      </span>
                                    </div>
                                    <p className="text-muted mb-0">
                                      Searching dividend data...
                                    </p>
                                  </div>
                                )}

                                {!dividendDataLoading && apiCallDone && (
                                  <>
                                    <Row>
                                      <Col>
                                        <DividendTable
                                          dividendData={dividendData}
                                          activeTab={activeTab}
                                        />
                                        <div className="d-flex justify-content-center">
                                          {hasNextPage && (
                                            <button
                                              className="btn pointer mt-3 mx-2"
                                              onClick={() => handleShowMore()}
                                            >
                                              {dividendDataLoading ||
                                                btnLoading ? (
                                                <span>
                                                  Loading...{" "}
                                                  <i
                                                    className="fa fa-spinner fa-spin  "
                                                    aria-hidden="true"
                                                  ></i>
                                                </span>
                                              ) : (
                                                "Show More"
                                              )}
                                            </button>
                                          )}
                                        </div>
                                      </Col>
                                    </Row>
                                  </>
                                )}
                              </>
                            )}
                          </div>
                        </div>

                        {ledgerTableData && ledgerTableData.length > 0 && (
                          <Row>
                            <Col>
                              <div className="card">
                                <div className="card-header">
                                  <h4 className="card-title text-primary">
                                    Affected Ledgers
                                  </h4>
                                </div>
                                <div className="card-body">
                                  <div className="table-responsive">
                                    <table className="table">
                                      <thead>
                                        <tr>
                                          <th>Code</th>
                                          <th>Name</th>
                                          <th>Description</th>
                                          <th className="text-right">
                                            Debit Amount
                                          </th>
                                          <th className="text-right">
                                            Credit Amount
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {ledgerTableData.map((data, index) => {

                                          totalDebitAmount += +data?.debit_amount || 0
                                          totalCreditAmount += +data?.credit_amount || 0

                                          return (
                                            <tr
                                              key={index}
                                              style={{
                                                background:
                                                  theme == "light"
                                                    ? ""
                                                    : "rgba(37,41,61,1)",
                                              }}
                                            >
                                              <td>{data.gl_code}</td>
                                              <td>{data.gl_name}</td>
                                              <td>
                                                <div className="d-flex">
                                                  {data.description}
                                                  {data?.description === "Dividend ROC" && data?.gl_name === "SALE OF UNITS" ?
                                                    (
                                                      <>
                                                        {` (`}
                                                        <CardColComponent
                                                          subTitle={numberWithCommas(parseFloat(totalDividendVal?.totalRefundUnits || 0)?.toFixed(4))}
                                                          simple={true}
                                                          units={true}
                                                        />
                                                        {`)`}
                                                      </>
                                                    ) :
                                                    data?.description === "Dividend Re-Invest" && data?.gl_name === "SALE OF UNITS" ?
                                                      (
                                                        <>
                                                          {` (`}
                                                          <CardColComponent
                                                            subTitle={numberWithCommas(parseFloat(totalDividendVal?.totalReinvestUnits || 0)?.toFixed(4))}
                                                            simple={true}
                                                            units={true}
                                                          />
                                                          {`)`}
                                                        </>
                                                      ) : null
                                                  }

                                                </div>
                                              </td>
                                              <td className="text-right">
                                                <CardColComponent
                                                  subTitle={numberWithCommas(
                                                    Number(
                                                      data.debit_amount || 0
                                                    ).toFixed(2)
                                                  )}
                                                  simple={true}
                                                  amount={true}
                                                />
                                              </td>
                                              <td className="text-right">
                                                <CardColComponent
                                                  subTitle={numberWithCommas(
                                                    Number(
                                                      data.credit_amount || 0
                                                    ).toFixed(2)
                                                  )}
                                                  simple={true}
                                                  amount={true}
                                                />
                                              </td>
                                            </tr>
                                          );
                                        })}
                                      </tbody>
                                      <tbody>
                                        <tr>
                                          <td>Total</td>
                                          <td></td>
                                          <td></td>
                                          <td className="text-right">
                                            <CardColComponent
                                              subTitle={numberWithCommas(
                                                Number(
                                                  totalDebitAmount || 0
                                                ).toFixed(2)
                                              )}
                                              simple={true}
                                              amount={true}
                                            />
                                          </td>
                                          <td className="text-right">
                                            <CardColComponent
                                              subTitle={numberWithCommas(
                                                Number(
                                                  totalCreditAmount || 0
                                                ).toFixed(2)
                                              )}
                                              simple={true}
                                              amount={true}
                                            />
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                                <div className="card-body">
                                  {selectedAnnouncementVal?.finalized ? (
                                    <Button
                                      size="sm"
                                      onClick={() =>
                                        setShowVerificationModal({
                                          open: true,
                                          state: "send-units",
                                        })
                                      }
                                      disabled={selectedAnnouncementVal?.paid}
                                    >
                                      <span>
                                        {selectedAnnouncementVal?.paid
                                          ? "Units Disbursed"
                                          : "Send Units"}
                                      </span>
                                    </Button>
                                  ) : (
                                    <Button
                                      size="sm"
                                      onClick={() =>
                                        setShowVerificationModal({
                                          open: true,
                                          state: "finalize",
                                        })
                                      }
                                    >
                                      <span>Finalize Entitlements</span>
                                    </Button>
                                  )}
                                </div>
                              </div>
                            </Col>
                          </Row>
                        )}
                      </Col>
                    </Row>
                  </>
                )
              }

              {renderModalForDisbursementProcessing()}

              <Modal
                className="otp-verification-modal"
                dialogClassName="modal-lg"
                show={isVerificationModalOpen.open}
                backdrop={isVerificationModalOpen.open}
                keyboard={false}
                centered
                onHide={() => {
                  setShowVerificationModal({ open: false, state: "" });
                }}
              >
                <div className="modal-header border-0 pb-0">
                  <div className="w-100 text-center">
                    <h5 className="modal-title fw-bold text-primary mb-2">
                      {isVerificationModalOpen.state === "send-units"
                        ? "Send Reinvest Units"
                        : "Dividend Authentication"}
                    </h5>
                    <p className="text-muted mb-0">
                      Please verify through OTP to process the{" "}
                      {isVerificationModalOpen.state === "send-units"
                        ? "assignment of reinvesting units"
                        : "finalization"}
                    </p>
                  </div>
                  <button
                    type="button"
                    className="btn-close bg-transparent border-0"
                    aria-label="Close"
                    onClick={() => {
                      setShowVerificationModal({ open: false, state: "" });
                    }}
                  >
                    x
                  </button>
                </div>

                <div className="modal-body px-4 py-3">
                  <OTPComponent
                    body={{ email, amc_code }}
                    onSuccess={async () => {
                      if (isVerificationModalOpen.state === "send-units")
                        await handleUnitDisbursement({
                          email,
                          amc_code,
                          fund_code: selectedFund,
                          announcement_id: selectedAnnouncementVal?.value,
                          disbursement_date: new Date(),
                        });
                      else
                        await handleFinalize({
                          email,
                          amc_code,
                          fund_code: selectedFund,
                          announcement_id: selectedAnnouncementVal?.value,
                          disbursement_date: new Date(),
                        });

                      setShowVerificationModal({ open: false, state: "" });

                      window.location.reload();
                    }}
                  />
                </div>
              </Modal>

              <Modal
                className=""
                dialogClassName="refundModal"
                show={isDividentRefundModalOpen}
                size="lg"
                backdrop={isDividentRefundModalOpen}
                onHide={() => {
                  setShowDividentRefundModal(false);
                }}
              >
                {selectedUnitHolderDivident && (
                  <SendPaymentModal
                    data={selectedUnitHolderDivident}
                    body={{
                      email,
                      amc_code,
                      fund_code: selectedFund,
                      announcement_id: selectedAnnouncementVal?.value,
                      disbursement_id:
                        selectedUnitHolderDivident?.dividend_disbursement_id,
                    }}
                  />
                )}
              </Modal>
            </Container>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default ProcessDisbursement;
